import { render } from "./TokenizePropertyBanner.vue?vue&type=template&id=de85cf48&scoped=true"
import script from "./TokenizePropertyBanner.vue?vue&type=script&lang=js"
export * from "./TokenizePropertyBanner.vue?vue&type=script&lang=js"

import "./TokenizePropertyBanner.vue?vue&type=style&index=0&id=de85cf48&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src420387374/src/relsify-frontpage-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de85cf48"]])

export default __exports__